import { styled, alpha } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

/**
 * ページコンテナ
 */
export const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default
}));

/**
 * ヘッダーセクション
 */
export const HeaderSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3)
}));

/**
 * タイトルエリア
 */
export const TitleArea = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8
}));

/**
 * アクションエリア
 */
export const ActionArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));

/**
 * 検索フィルターセクション
 */
export const FilterSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(3),
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  flexWrap: 'wrap'
}));

/**
 * テーブルコンテナ
 */
export const TableSection = styled(Box)(() => ({
  width: '100%'
}));

/**
 * エラーアラートコンテナ
 */
export const ErrorContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));

/**
 * ルールチップスタイル（割り当て可能）
 */
export const AssignableChipStyle = {
  backgroundColor: (theme: { palette: { success: { light: string } } }) =>
    alpha(theme.palette.success.light, 0.2),
  color: (theme: { palette: { success: { dark: string } } }) =>
    theme.palette.success.dark,
  borderColor: (theme: { palette: { success: { main: string } } }) =>
    theme.palette.success.main
};

/**
 * ルールチップスタイル（割り当て禁止）
 */
export const ProhibitedChipStyle = {
  backgroundColor: (theme: { palette: { error: { light: string } } }) =>
    alpha(theme.palette.error.light, 0.2),
  color: (theme: { palette: { error: { dark: string } } }) =>
    theme.palette.error.dark,
  borderColor: (theme: { palette: { error: { main: string } } }) =>
    theme.palette.error.main
};
